import { useEffect, useRef, useState } from "react";
import useCookie from "../../hooks/useCookie";

export default function useController() {
  const { getCookie } = useCookie();

  const refGenderList = useRef([]);

  const [isGenderDisabled, setIsGenderDisabled] = useState(false);

  const detectGender = () => {
    // item 4: тем же набором признаков, что и блок в RegisterPage — иначе радио снова
    // становилось активным, когда короткоживущая кука inviterGender протухала.
    const gender =
      getCookie("inviterGender") ||
      getCookie("isInvited") ||
      getCookie("invite_link");
    if (gender) {
      setIsGenderDisabled(true);
    }
  };

  useEffect(() => {
    detectGender();
  }, []);

  return {
    refGenderList,
    // currentGender,
    isGenderDisabled,
  };
}
